"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseN = void 0;
class BaseN {
    constructor(alphabet) {
        this.alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿĀāĂăĄąĆćĈĉĊċČčĎďĐđĒēĔĕĖėĘęĚěĜĝĞğĠġĢģĤĥĦħĨĩĪīĬĭĮįİıĲĳĴĵĶķĸĹĺĻļĽľĿŀŁłŃńŅņŇňŉŊŋŌōŎŏŐőŒœŔŕŖŗŘřŚśŜŝŞşŠšŢţŤťŦŧŨũŪūŬŭŮůŰűŲųŴŵŶŷŸŹźŻżŽžſƀƁƂƃ';
        this.alphabet = alphabet || this.alphabet;
        this.base = this.alphabet.length;
    }
    encode(enc) {
        enc = parseInt(enc);
        if (typeof enc !== 'number')
            return '';
        let encoded = '';
        while (enc) {
            const remainder = enc % this.base;
            enc = Math.floor(enc / this.base);
            encoded = this.alphabet[remainder].toString() + encoded;
        }
        return encoded;
    }
    decode(dec) {
        if (typeof dec !== 'string' && !(dec instanceof String))
            throw '"decode" only accepts strings.';
        let decoded = 0;
        while (dec) {
            const alphabetPosition = this.alphabet.indexOf(dec[0]);
            if (alphabetPosition < 0)
                throw '"decode" can\'t find "' + dec[0] + '" in the alphabet: "' + this.alphabet + '"';
            const powerOf = dec.length - 1;
            decoded += alphabetPosition * (Math.pow(this.base, powerOf));
            dec = dec.substring(1);
        }
        return decoded;
    }
}
exports.BaseN = BaseN;
//# sourceMappingURL=baseN.js.map